const scope = "perfReturns";
export default scope;
